import {
  setProductType,
  setSelectedProduct,
} from "@redux/slices/appStateSlice";
import {
  resetFiltersPayload,
  setSectionName,
} from "@redux/slices/searchFilters";
import Routes from "@navigations/Routes";
import { getProductColor } from "@utils/product/productTheme";
import { navigate } from "@navigations/utils/RootNavigation";

export const navigateToRoute = (
  productType: string,
  dispatch,
  theme,
  sectionName?: string,
  productPrefix?: string
) => {
  dispatch(setProductType(productType));
  dispatch(setSelectedProduct(getProductColor(productType)));
  dispatch(resetFiltersPayload());
  const params: any = {
    productType: productType,
    fromResultScreen: false,
    productPrefix,
  };

  if (sectionName) {
    params.sectionName = sectionName;
    dispatch(setSectionName(sectionName));
  }

  const destinationRoute = theme.isMobile
    ? Routes.FilterScreen
    : Routes.FilterSplitScreen;

  navigate(Routes.ExploreNavigator, {
    initial: false,
    screen: destinationRoute,
    params,
  });
};
